<template>
    <el-card class="page_card product_index wai_pages" ref="card">
        <div slot="header" class="clearfix">
            <span>产品管理</span>
        </div>
        <el-tabs tab-position="left" style="height: 100%;" v-model="activeName" @tab-click="handleClick">
            <el-tab-pane style="padding: 20px 15px" v-for="(goods,index) of products" :name="'a'+index" :key="goods.id" class="wai">
                <div slot="label" style="text-align: left;width: 100%">
                    <span style="text-align: left;display: inline-block;width: 50%">
                        <svg-icon icon-class="water" />
                        {{goods.name}}
                    </span>
                    <span style="display: inline-block;text-align: right;width: 50%">
                        <el-link :underline="false" size="mini" style="margin-left: 30px" type="success" v-if="goods.isMain">主产品</el-link>
                    </span>
                </div>
                <goods_detail :data="goods" :companys="componys"  :mode="'detail'" :ref="'goods_detail'+goods.id" :key="goods.id" @setMain="setMain" @setData="setData"></goods_detail>
            </el-tab-pane>
            <el-tab-pane style="padding: 20px 15px" class="wai" v-if="checkPermission(['btn:product_add'])">
                <div slot="label" style="text-align: left;width: 100%" @click="btnAdd">
                    <svg-icon icon-class="add" /> 添加新产品
                </div>
            </el-tab-pane>
        </el-tabs>
        <!--产品添加-->
        <el-dialog title="添加产品" :visible.sync="add_price_dialog" width="30%">
            <el-form ref="form" :model="form" :rules="rules" label-width="120px">
                    <el-form-item label="产品名称" prop="name">
                        <el-input v-model="form.name"  style="width: 200px" placeholder="请输入产品名称" maxlength="10" show-word-limit></el-input>
                    </el-form-item>
                    <el-form-item label="产品图片" prop="imgUrl">
                        <div>
                            <el-image
                                style="width: 180px; height: 160px;border-radius:10px;"
                                :src="form.imgUrl"
                                fit="contain">
                                <div slot="error" class="image-slot">
                                    <i class="el-icon-picture-outline"></i>
                                </div>
                            </el-image>
                        </div>
                    </el-form-item>
                    <el-form-item>
                        <div>
                            <input type="file" name="file" style="display:none;" ref="upload_file" @change="file_change($event)">
                            <el-button type="primary" plain :loading="is_upload" @click="choseImg()">{{is_upload?'正在上传...':'选择图片'}}</el-button>
                        </div>
                        <div style="font-size: 12px;color: #aaa">
                            只能上传jpg,jpeg,png,gif格式的图片,且大小不能大于500KB
                        </div>
                    </el-form-item>

                    <el-form-item label="是否主产品">
                        <el-switch
                            v-model="form.isMain"
                            active-color="#13ce66"
                            inactive-color="#ff4949"
                            active-text="是"
                            inactive-text="否">
                        </el-switch>
                    </el-form-item>
                    <!-- <el-form-item label="是否启用">
                        <el-switch
                            v-model="form.isShow"
                            active-color="#13ce66"
                            inactive-color="#ff4949"
                            active-text="是"
                            inactive-text="否">
                        </el-switch>
                    </el-form-item> -->
                    <el-form-item label="">
                        <el-button plain :loading="is_post" type="primary" @click="addSubmit" >提 交</el-button>
                    </el-form-item>
                </el-form>
        </el-dialog>
    </el-card>
</template>

<script>
import can from "@/directive/can/index.js"
import request from '@/utils/request'
import goods_detail from './pane/goods_detail'
import {stringTrim} from '@/utils/elvalid'
import {mapGetters} from 'vuex'
import checkPermission from '@/utils/permission' 

export default {
    name: 'product_index',
    directives:{can},
    components:{
        goods_detail
    },
    computed: {
        // 使用对象展开运算符将 getter 混入 computed 对象中
        ...mapGetters([
            'permissions'
        ])
    },
    data(){
        return {
            is_ok:false,
            is_post:false,
            is_loading:false,
            products:[],
            addForm:{
                name:"",
                price:"",
                imgUrl:"",
            },
            add:{
                id:999999999,name:"LNG",isShow:true,isMain:true
            },
            activeName:"a0",
            activeNames: "first",
            add_price_dialog:false,
            form:{
                name:"",
                imgUrl:"",
                isMain:false,
                isShow:true
            },
            rules:{
                name:[
                    { required: true, message: '请输入产品名称', trigger: 'blur' },
                    { validator: stringTrim, trigger: 'blur' }
                ],
                imgUrl:[
                    { required: true, message: '请上传产品图片', trigger: 'blur' }
                ]
            },
            is_upload:false,
            componys:[],
        }
    },
    methods:{
        checkPermission,
        handleClick(tab, event) {
            this.$refs["goods_detail"+this.products[tab.index].id][0].getPrice();
        },
        btnAdd(){
            this.add_price_dialog=true;
        },
        // pushOne(data){
        //     this.products.push(data);
        // },
        //选择图片
        choseImg(){
            this.$refs["upload_file"].click();
        },
        //上传图片
        file_change(e){
            let file = e.target.files[0];
            if(typeof file == "undefined"){
                return false;
            }
            this.is_upload = true;
            this.$store.dispatch("upload/uploadImg",{file:file,size:1024*512}).then(res=>{
                this.is_upload = false;
                this.form.imgUrl = res.url;
                this.$message.success("图片上传成功!");
            }).catch(err=>{
                if(err.type == "size"){
                    this.$message.warning("请上传不大于500kb的图片!");
                }else{
                    this.$message.warning(err.msg);
                }
                this.is_upload = false;
                console.log(err);
            });
        },
        addSubmit(){
            this.$refs["form"].validate(valid=>{
                if(!valid) return false;
                this.is_post = true;
                request.post("goods/create",this.form).then(res=>{
                    this.$message.success("新增产品成功");
                    this.form = {
                        name:"",
                        imgUrl:"",
                        isMain:false,
                        isShow:false
                    };
                    this.$refs["form"].resetFields();
                    this.$emit('getAdd',res.data);
                    this.is_post = false;
                    this.add_price_dialog=false;
                    this.getData();
                }).catch(err=>{
                    this.is_post = false;
                });
            });
        },
        setData(data){
            for(let item of this.products){
                if(item.id == data.id){
                    for(let k of Object.keys(item)){
                        if(k != "isMain" && k != "price"){
                            item[k] = data[k];
                        }
                    }
                }
            }
        },
        has_permission(permission){
            return this.permissions.includes(permission);
        },
        setMain(data){
            for(let item of this.products){
                if(item.id == data.id){
                    item.isMain = data.isMain;
                }else{
                    item.isMain = false;
                    this.$refs["goods_detail"+item.id][0].setMainFalse()
                    
                }
            }
        },
        getData(){
            request.get("goods/list?keyword=").then(res=>{
                this.products = res.data;
            }).catch(err=>{

            });
        },
        getGoodsList() {
            request.get("goods/dropdown").then((res) => {
            this.goods_list = this.goods_list.concat(res.data);
            }).catch((err) => {
            });
        },
        getCompany(){
            request.get("company/option").then(res=>{
                this.componys = res.data;
            }).catch(err=>{
            });
        },

    },
    created(){
        this.getData();
    },
    mounted() {
        this.has_permission();
        this.getGoodsList();
        this.getCompany();
    }
}
</script>

<style scoped lang="scss">
   .price{
       margin-left:70%;
   }
</style>
